ARROW_DOWN_OUTLINE